<template>
  <b-container>
    <b-row class="mt-3 mb-1">
      <b-col>
        <h4 class="text-secondary">404 Error</h4>
        <h5>We're sorry, but the page you requested could not be found.</h5>
        <p>
          <router-link :to="{ name: 'Home' }"
            >Go to the Active Trader message board</router-link
          >
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
